import React, { useState } from 'react';
import {FormGroup, FormControlLabel, Checkbox, Button,  TextField, Box, Alert, Typography  } from "@mui/material"
import CustomLoader from '../../../core/components/common/custom-loader.component';
import CustomFormSuccess from '../../../core/components/common/custom-form-success.component';
import RoleManagementService from '../services/api/role-managment-service';

const EditRoleForm = ({handleClose, row, handleRecordChange}) => {
    console.log(row)

    const [roleName, setRoleName] = useState(row.role);
    const [description, setDescription] = useState(row.description);
    const [errorMessage, setErrorMessage] = useState();
    const [statusCode, setStatusCode] = useState();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const [canViewCreated, setCanViewCreated] = useState(row?.can_only_view_created);
    const [canViewAssigned, setCanViewAssigned] = useState(row?.can_only_view_assigned);


    const handleSubmit = () => {
        let parameters = {
            'id': row.id
        }

        let payload = {
            role : roleName,
            description : description,
            profile_type: row.profile_type,
            can_only_view_assigned: (canViewAssigned) ? 1 : 0,
            can_only_view_created: (canViewCreated) ? 1 : 0,
        }

        let request =RoleManagementService.updateRole(parameters, payload).then()

        request.then((result) => {
            setLoading(false);
            let apiResponse = result.data;
            console.log("apiResponse", apiResponse)
            setSuccess(true)
            handleRecordChange();
        }).catch((error) => {
            console.log("error", error)
            setLoading(false);
            setSuccess(false)
            setStatusCode(error.status)
            const errorMessage = error?.response?.data?.error || error.message;
            setErrorMessage(errorMessage)
        })
    }

    return (
        <div>
            {loading ? ( 
                <CustomLoader />
            ) : (
                <div>
                    {success ? ( 
                            <CustomFormSuccess handleClose={handleClose}
                            message={"Role was successfully updated"}
                         />
                    ) : (
                    <div>
                        {errorMessage && (
                            <Alert style={{marginBottom: "12px"}} severity="error">
                                {errorMessage}.
                                <Typography sx={{ fontSize: '0.5rem' }}>
                                    Status Code: {statusCode}
                                </Typography>
                            </Alert>
                        )}
                        <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField label="Role Name" variant="outlined" fullWidth sx={{mt: 1}}
                            value={roleName} 
                            onChange={(e) => setRoleName(e.target.value)}
                            />
                            <TextField
                                label="Description"
                                variant="outlined"
                                multiline
                                rows={4}  // Number of rows for the textarea
                                fullWidth
                                value={description}
                                onChange={(e) => setDescription(e.target.value)} 
                            />

                             <FormGroup>
                                <FormControlLabel label="Can only view created"
                                    control={
                                        <Checkbox checked={canViewCreated} onChange={(e) => setCanViewCreated(e.target.checked)}/>
                                    }
                                />
                                <FormControlLabel label="Can only view assigned"
                                    control={
                                        <Checkbox checked={canViewAssigned} onChange={(e) => setCanViewAssigned(e.target.checked)}/>
                                    }
                                />
                            </FormGroup>

                            <Button type="button" variant="contained" sx={{ alignSelf: 'flex-end' }} onClick={handleSubmit}>
                            Submit
                            </Button>
                        </Box>
                    </div>

                )}
                </div>
            )}
        </div>

    )
}

export default EditRoleForm